// @ts-check
import { isNil } from 'es-toolkit';
import { z } from 'zod';

const clientEnvSchema = z
  .object({
    NEXT_PUBLIC_VERCEL_ENV: z.enum(['demo', 'development', 'preview', 'production', 'staging']).default('development'),
    NEXT_PUBLIC_VERCEL_URL: z.string().default('localhost:3000'),
    NEXT_PUBLIC_SITE_URL: z.string().optional(),
    NEXT_PUBLIC_GOOGLE_MAPS_API_KEY: z.string().optional(),
    NEXT_PUBLIC_VERCEL_DEPLOYMENT_ID: z.string().optional(),
    NEXT_PUBLIC_VERCEL_SKEW_PROTECTION_ENABLED: z.string().optional(),
    NEXT_PUBLIC_PORT: z
      .string()
      .optional()
      .transform((val) => (!isNil(val) ? Number(val) : undefined)),
  })
  .transform((env) => ({
    ...env,
    /** The base url for the given environment, starting with `https://`. For example, `https://app.savvywealth.com` or `http://localhost:3000` */
    BASE_URL: baseUrl(
      env.NEXT_PUBLIC_VERCEL_ENV,
      env.NEXT_PUBLIC_SITE_URL,
      env.NEXT_PUBLIC_VERCEL_URL,
      env.NEXT_PUBLIC_PORT,
    ),
  }));

export default clientEnvSchema;

/** @typedef {z.input<typeof clientEnvSchema>} ClientEnvInput */

/**
 * @param {'demo' | 'development' | 'preview' | 'production' | 'staging'} env
 * @param {string | undefined} siteUrl
 * @param {string} vercelUrl
 * @param {number | undefined} nextPublicPort
 * @returns {string}
 */
function baseUrl(env, siteUrl, vercelUrl, nextPublicPort) {
  switch (env) {
    case 'production':
      return `https://${siteUrl || vercelUrl}`;
    case 'preview':
    case 'demo':
    case 'staging':
      return `https://${vercelUrl}`;
    case 'development':
      return `http://localhost:${nextPublicPort ?? 3000}`;
  }
}
